function RacePrivate() {
  return <div>THIS IS PRIVATE PAGE</div>
}

export default RacePrivate
